import React from "react";
import NotificationCard from "../../../../components/molecules/NotificationCard";
import NoNotifications from "../../../../components/molecules/NoNotifications"

export default function all({ notification }) {
  return (
    <>
      {notification
        .sort((a, b) => (a.sentAt > b.sentAt ? -1 : a.sentAt < b.sentAt ? 1 : 0))
        .map((noti, i) => (
          <div className='app_panel px-3 pt-2 mb-2' key={i}>
            <NotificationCard notification={noti} />
          </div>
        ))}
      {notification.length === 0 ? (
        <NoNotifications />
      ) : null}
    </>
  );
}
